"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Attachment = Attachment;
exports.AttachmentAction = AttachmentAction;
exports.AttachmentActions = AttachmentActions;
exports.AttachmentContent = AttachmentContent;
exports.AttachmentDescription = AttachmentDescription;
exports.AttachmentGroup = AttachmentGroup;
exports.AttachmentMedia = AttachmentMedia;
exports.AttachmentTitle = AttachmentTitle;
exports.AttachmentTrigger = AttachmentTrigger;
var React = _interopRequireWildcard(require("react"));
var _classVarianceAuthority = require("class-variance-authority");
var _utils = require("@design/lib/utils");
var _radixUi = require("radix-ui");
var _button = require("@design/ui/button");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "state", "size", "orientation"],
  _excluded2 = ["className", "variant"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"],
  _excluded7 = ["className", "variant", "size"],
  _excluded8 = ["className", "asChild", "type"],
  _excluded9 = ["className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var attachmentVariants = (0, _classVarianceAuthority.cva)("group/attachment relative flex w-fit max-w-full min-w-0 shrink-0 flex-wrap rounded-xl border bg-card text-card-foreground transition-colors focus-within:ring-1 focus-within:ring-ring/50 has-[>a,>button]:hover:bg-muted/50 data-[state=error]:border-destructive/30 data-[state=idle]:border-dashed", {
  variants: {
    size: {
      default: "gap-2 text-sm has-data-[slot=attachment-content]:px-2.5 has-data-[slot=attachment-content]:py-2 has-data-[slot=attachment-media]:p-2",
      sm: "gap-2.5 text-xs has-data-[slot=attachment-content]:px-2 has-data-[slot=attachment-content]:py-1.5 has-data-[slot=attachment-media]:p-1.5",
      xs: "gap-1 rounded-lg p-1 text-xs"
    },
    orientation: {
      horizontal: "min-w-40 items-center",
      vertical: "w-24 flex-col has-data-[slot=attachment-content]:w-30"
    }
  }
});
function Attachment(_ref) {
  var className = _ref.className,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? "done" : _ref$state,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "default" : _ref$size,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? "horizontal" : _ref$orientation,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "attachment",
    "data-state": state,
    "data-size": size,
    "data-orientation": orientation,
    className: (0, _utils.cn)(attachmentVariants({
      size: size,
      orientation: orientation
    }), className)
  }, props), {}, {
    "data-sentry-component": "Attachment",
    "data-sentry-source-file": "attachment.tsx"
  }));
}
var attachmentMediaVariants = (0, _classVarianceAuthority.cva)("relative flex aspect-square w-10 shrink-0 items-center justify-center overflow-hidden rounded-lg text-foreground group-data-[orientation=vertical]/attachment:w-full group-data-[size=sm]/attachment:w-8 group-data-[size=xs]/attachment:w-7 group-data-[size=xs]/attachment:rounded-md group-data-[state=error]/attachment:bg-destructive/10 group-data-[state=error]/attachment:text-destructive group-data-[orientation=vertical]/attachment:*:data-[slot=spinner]:size-6! [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 group-data-[orientation=vertical]/attachment:[&_svg:not([class*='size-'])]:size-6 group-data-[size=xs]/attachment:[&_svg:not([class*='size-'])]:size-5", {
  variants: {
    variant: {
      icon: "",
      image: "opacity-60 group-data-[state=done]/attachment:opacity-100 group-data-[state=idle]/attachment:opacity-100 *:[img]:aspect-square *:[img]:w-full *:[img]:object-cover"
    }
  },
  defaultVariants: {
    variant: "icon"
  }
});
function AttachmentMedia(_ref2) {
  var className = _ref2.className,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? "icon" : _ref2$variant,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "attachment-media",
    "data-variant": variant,
    className: (0, _utils.cn)(attachmentMediaVariants({
      variant: variant
    }), className)
  }, props), {}, {
    "data-sentry-component": "AttachmentMedia",
    "data-sentry-source-file": "attachment.tsx"
  }));
}
function AttachmentContent(_ref3) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "attachment-content",
    className: (0, _utils.cn)("max-w-full min-w-0 flex-1 leading-tight group-data-[orientation=vertical]/attachment:px-1", className)
  }, props), {}, {
    "data-sentry-component": "AttachmentContent",
    "data-sentry-source-file": "attachment.tsx"
  }));
}
function AttachmentTitle(_ref4) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({
    "data-slot": "attachment-title",
    className: (0, _utils.cn)("block max-w-full min-w-0 truncate font-normal group-data-[state=processing]/attachment:shimmer group-data-[state=uploading]/attachment:shimmer", className)
  }, props), {}, {
    "data-sentry-component": "AttachmentTitle",
    "data-sentry-source-file": "attachment.tsx"
  }));
}
function AttachmentDescription(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread(_objectSpread({
    "data-slot": "attachment-description",
    className: (0, _utils.cn)("mt-0.5 block min-w-0 truncate text-xs text-muted-foreground group-data-[state=error]/attachment:text-destructive/80", "max-w-full", className)
  }, props), {}, {
    "data-sentry-component": "AttachmentDescription",
    "data-sentry-source-file": "attachment.tsx"
  }));
}
function AttachmentActions(_ref6) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "attachment-actions",
    className: (0, _utils.cn)("relative z-20 flex shrink-0 items-center group-data-[orientation=vertical]/attachment:absolute group-data-[orientation=vertical]/attachment:top-3 group-data-[orientation=vertical]/attachment:right-3 group-data-[orientation=vertical]/attachment:gap-1", className)
  }, props), {}, {
    "data-sentry-component": "AttachmentActions",
    "data-sentry-source-file": "attachment.tsx"
  }));
}
function AttachmentAction(_ref7) {
  var className = _ref7.className,
    variant = _ref7.variant,
    _ref7$size = _ref7.size,
    size = _ref7$size === void 0 ? "icon-xs" : _ref7$size,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, _objectSpread(_objectSpread({
    "data-slot": "attachment-action",
    variant: variant !== null && variant !== void 0 ? variant : "ghost",
    size: size,
    className: (0, _utils.cn)(className)
  }, props), {}, {
    "data-sentry-element": "Button",
    "data-sentry-component": "AttachmentAction",
    "data-sentry-source-file": "attachment.tsx"
  }));
}
function AttachmentTrigger(_ref8) {
  var className = _ref8.className,
    _ref8$asChild = _ref8.asChild,
    asChild = _ref8$asChild === void 0 ? false : _ref8$asChild,
    type = _ref8.type,
    props = _objectWithoutProperties(_ref8, _excluded8);
  var Comp = asChild ? _radixUi.Slot.Root : "button";
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Comp, _objectSpread(_objectSpread({
    "data-slot": "attachment-trigger",
    type: asChild ? undefined : type !== null && type !== void 0 ? type : "button",
    className: (0, _utils.cn)("absolute inset-0 z-10 outline-none", className)
  }, props), {}, {
    "data-sentry-element": "Comp",
    "data-sentry-component": "AttachmentTrigger",
    "data-sentry-source-file": "attachment.tsx"
  }));
}
function AttachmentGroup(_ref9) {
  var className = _ref9.className,
    props = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    "data-slot": "attachment-group",
    className: (0, _utils.cn)("flex min-w-0 scroll-fade-x snap-x snap-mandatory scroll-px-1 scrollbar-none gap-3 overflow-x-auto overscroll-x-contain py-1 *:data-[slot=attachment]:flex-none *:data-[slot=attachment]:snap-start", className)
  }, props), {}, {
    "data-sentry-component": "AttachmentGroup",
    "data-sentry-source-file": "attachment.tsx"
  }));
}